import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Header from './components/Header';
import Home from './components/Home';
import Table from './components/Table';

import './css/Index.scss';
import './css/App.scss';

function App() {
  return (
    <div className="App">
      <Header />
      <Router>
        <Routes>
          <Route path="table" element={<Table />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
